// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Cell, Spinner } from '@gandi/ui';

import { useExtendedSuggestion } from '../../ProvidedArea/modules';

import { AvailabilityPrice } from './AvailabilityPrice';

import styles from './AvailabilityCell.scss';

export type Props = {
  isLoading: boolean,
  fqdn: string,
};

function renderCell(content: React.Node): React.MixedElement {
  return (
    <Cell
      flexWrap
      boxSizing="border"
      paddingLeft={null}
      paddingY="xsmall"
      className={styles.cell}
    >
      {content}
    </Cell>
  );
}

export default function AvailabilityCell({
  isLoading,
  fqdn,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();
  const {
    currency,
    needsPhaseSelection,
    price,
    suggestion,
    minDuration,
    normalPrice,
    renewPrice,
    hasDiscount,
    phasePrice,
    priceDiff,
    renewMinDuration,
  } = useExtendedSuggestion({ fqdn });

  if (isLoading) {
    return renderCell(<Spinner name="dots" />);
  }

  if (suggestion?.availability === 'lang_required') {
    return null;
  }

  if (suggestion && suggestion.availability !== 'available') {
    return renderCell(<span>{__('Unavailable')}</span>);
  }

  if (suggestion?.error) {
    return renderCell(<span>{__('Error')}</span>);
  }

  if (suggestion && phasePrice) {
    return (
      <AvailabilityPrice
        currency={currency}
        fqdn={suggestion.fqdn}
        hasDiscount={hasDiscount}
        minDuration={minDuration}
        needsPhaseSelection={needsPhaseSelection}
        normalPrice={normalPrice}
        price={price}
        priceDiff={priceDiff}
        renewMinDuration={renewMinDuration}
        renewPrice={renewPrice}
      />
    );
  }

  return renderCell(<span>{__('Error')}</span>);
}

AvailabilityCell.Error = function AvailabilityCellError(): React.MixedElement {
  const { __ } = useTranslator();
  return renderCell(<span>{__('Error')}</span>);
};
